import React from 'react';
// import ScrollToTop from '../ScrollToTop';
// import SignIn from '../SignIn';

const SignInPage = () => {
  return  (
  <>
 
  {/* <ScrollToTop/> */}
  {/* <SignIn/> */}
  </>
  )
};

export default SignInPage;
